var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuepdf"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('iframe',{attrs:{"src":_vm.dataUrl,"width":"100%","height":"1000","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }